import React from 'react';
import AspectRatio from 'components/AspectRatio';
import * as S from './styles';

export interface GradientIconProps {
  children?: React.ReactNode;
  className?: string;
}

/**
 * A circular gradient background with an icon in the foreground
 */
export const GradientIcon: React.FC<GradientIconProps> = ({
  children,
  className,
}) => (
  <AspectRatio ratio={1}>
    <S.Root className={className}>{children}</S.Root>
  </AspectRatio>
);

export default GradientIcon;
